(() => {
if(window.trekcampExperience)return;window.trekcampExperience=true;
const c=JSON.parse(document.getElementById('tc-ex-copy')?.textContent||'{}'),root=window.Shopify?.routes?.root||'/',d=document.getElementById('tc-ex-dialog');if(!d)return;
const body=d.querySelector('[data-tc-ex-body]'),title=d.querySelector('h2'),status=d.querySelector('[data-tc-ex-status]'),live=document.querySelector('[data-tc-ex-live]'),valid=h=>typeof h==='string'&&/^[a-z0-9][a-z0-9-]*$/.test(h);
const read=k=>{try{const a=JSON.parse(localStorage.getItem(k)||'[]');return Array.isArray(a)?[...new Set(a.filter(valid))].slice(0,50):[];}catch{return[];}},write=(k,v)=>{try{localStorage.setItem(k,JSON.stringify(v));}catch{}};
let saved=read('trekcamp-wishlist'),recent=read('trekcamp-recent'),opener,mode,revision=0;const cache=new Map();
// Card Wishlist feedback: only the saved-heart state changes, with no
// animated checkmark overlay. Persistence, counts and accessibility remain.
const get=async h=>{if(!valid(h))throw Error();if(!cache.has(h))cache.set(h,fetch(root+'products/'+h+'.js').then(r=>{if(!r.ok)throw Error();return r.json();}).catch(e=>{cache.delete(h);throw e;}));return cache.get(h);};
const el=(tag,text,cls)=>{const n=document.createElement(tag);if(text)n.textContent=text;if(cls)n.className=cls;return n;},money=v=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:window.Shopify?.currency?.active||'PKR'}).format(v/100);
const image=(source,alt)=>{const n=el('img'),src=typeof source==='string'?source:source?.src;if(src&&/^(https:\/\/|\/\/|\/cdn\/)/.test(src)){n.src=src;n.alt=alt;n.loading='lazy';n.width=500;n.height=500;}return n;};
const sync=()=>{document.querySelectorAll('[data-tc-wishlist]').forEach(b=>{const bubble=b.querySelector('[data-tc-wishlist-bubble]'),count=b.querySelector('[data-tc-wishlist-count]');if(bubble)bubble.hidden=saved.length===0;if(count&&count.textContent!==String(saved.length))count.textContent=String(saved.length);if(b.classList.contains('tc-mobile-wishlist-entry')&&count)count.hidden=saved.length===0;b.setAttribute('aria-label',c.wishlist+(saved.length?' ('+saved.length+')':''));});document.querySelectorAll('[data-tc-save]').forEach(b=>{b.hidden=false;const chosen=saved.includes(b.dataset.tcSave);b.setAttribute('aria-pressed',String(chosen));b.setAttribute('aria-label',chosen?c.saved:c.save);b.classList.toggle('is-saved',chosen);const label=b.querySelector('[data-tc-save-label]');const text=b.classList.contains('tc-ex-icon')?(chosen?c.added_short:c.add_short):(chosen?c.saved:c.save);if(label&&label.textContent!==text)label.textContent=text;});document.querySelectorAll('[data-tc-quick],[data-tc-wishlist],[data-tc-share]').forEach(b=>b.hidden=false);};
const open=(label,m,trigger)=>{opener=trigger;mode=m;revision++;if(title.parentElement!==d)d.insertBefore(title,body);d.classList.toggle('tc-ex-dialog--quick',m==='quick');title.textContent=label;status.textContent='';body.replaceChildren();if(!d.open)d.showModal();return revision;};
d.addEventListener('close',()=>{revision++;if(opener?.isConnected)opener.focus();});d.querySelector('[data-tc-ex-close]').addEventListener('click',()=>d.close());
const card=p=>{const n=el('article',null,'tc-ex-tile'),media=el('div',null,'tc-ex-tile-media'),a=el('a');a.href=root+'products/'+p.handle;a.append(image(p.featured_image,p.title));media.append(a);const b=el('button',null,'tc-ex-icon tc-ex-save');b.type='button';b.dataset.tcSave=p.handle;b.setAttribute('aria-pressed',String(saved.includes(p.handle)));b.setAttribute('aria-label',saved.includes(p.handle)?c.saved:c.save);b.classList.toggle('is-saved',saved.includes(p.handle));b.innerHTML="<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z\"/></svg>";const label=el('span',saved.includes(p.handle)?c.added_short:c.add_short,'tc-ex-tooltip');label.dataset.tcSaveLabel='';label.setAttribute('role','tooltip');b.append(label);media.append(b);const text=el('a');text.href=a.href;text.append(el('h3',p.title),el('p',money(p.price)));n.append(media,text);return n;};
const wishlist=async trigger=>{const token=open(c.wishlist,'wishlist',trigger);body.append(el('p',c.local));if(!saved.length){body.append(el('p',c.empty));return;}status.textContent=c.loading;const results=await Promise.allSettled(saved.map(get));if(token!==revision)return;const grid=el('div',null,'tc-ex-grid');let failed=0;results.forEach(r=>{if(r.status==='fulfilled')grid.append(card(r.value));else failed++;});body.append(grid);status.textContent=failed?c.error:'';};
// Quick View derives colour indicators and colour-specific gallery images from the
// actual product page. No second inventory/colour mapping is maintained here.
const tcQuickPages=new Map();
const tcQuickPage=(h,v)=>{
  const key=h+':'+v.id;
  if(!tcQuickPages.has(key)){
    const url=root+'products/'+h+'?variant='+encodeURIComponent(String(v.id));
    tcQuickPages.set(key,fetch(url).then(r=>{if(!r.ok)throw Error('Quick View product page unavailable');return r.text();}).then(html=>new DOMParser().parseFromString(html,'text/html')).catch(e=>{tcQuickPages.delete(key);throw e;}));
  }
  return tcQuickPages.get(key);
};
const tcQuickColorFallback=name=>{
  const n=String(name||'').toLowerCase().trim();
  const known={'olive green':'#68734c','royal blue':'#2455a3','crimson red':'#be244a','fluorescent yellow':'#d9fc2d','dark grey':'#41454a','dark beige':'#a38d72','vibrant red':'#d7413c','black':'#27272a','blue':'#3971ab','green':'#568366','sky blue':'#56b8da'};
  if(n.includes('camo'))return 'conic-gradient(from 30deg,#445742 0 22%,#b5a180 22% 38%,#333f31 38% 55%,#7a7652 55% 75%,#56624a 75% 100%)';
  if(n==='green / white')return 'linear-gradient(90deg,#568366 0 50%,#fff 50% 100%)';
  if(n==='blue / grey')return 'linear-gradient(90deg,#3971ab 0 50%,#898e93 50% 100%)';
  return known[n]||'repeating-linear-gradient(135deg,#e5e5e5 0 6px,#fafafa 6px 12px)';
};
const tcQuickPhotos=(page,color)=>{
  const items=[...page.querySelectorAll('media-gallery slideshow-slide img')].map(img=>({
    src:img.getAttribute('src')||img.getAttribute('data-src')||'',
    alt:img.getAttribute('alt')||''
  })).filter(item=>/^(https:\/\/|\/\/|\/cdn\/)/.test(item.src));
  const matches=items.filter(item=>item.alt.toLowerCase().includes(String(color).toLowerCase()));
  const list=matches.length?matches:items;
  const seen=new Set();
  return list.filter(item=>{const key=item.src.split('?')[0];if(seen.has(key))return false;seen.add(key);return true;}).slice(0,20);
};
const quick=async(h,trigger)=>{
  const token=open(c.quick,'quick',trigger);
  status.textContent=c.loading;
  try{
    const p=await get(h);
    if(token!==revision)return;
    title.textContent=p.title;
    const variants=p.variants||[];
    let selected=variants.find(v=>v.available)||variants[0];
    let imageRevision=0;
    const layout=el('div',null,'tc-ex-quick');
    const gallery=el('div',null,'tc-ex-gallery');
    const mainImage=image(selected?.featured_image?.src||p.featured_image,p.title);
    mainImage.classList.add('tc-ex-main-image');
    const thumbs=el('div',null,'tc-ex-thumbnails');
    thumbs.setAttribute('aria-label','Product images');
    gallery.append(mainImage,thumbs);
    const info=el('div',null,'tc-ex-quick-details');
    const price=el('p',null,'tc-ex-price');
    layout.append(gallery,info);
    // In Quick View only, move the actual dialog heading into the right-side
    // details column. The shared dialog opener restores it for other views.
    info.append(title,price);
    const choices=[];
    let selectedName;
    if(variants.length>1){
      const picker=el('div',null,'variant-picker tc-ex-variant-picker');
      const group=el('fieldset',null,'variant-option variant-option--buttons variant-option--swatches tc-ex-variants');
      const optionName=(p.options||[]).find(name=>/^(colors?|colou?rs?|colou?rway)$/i.test(name))||(p.options||[])[0]||c.choose;
      const legend=el('legend',optionName+': ');
      selectedName=el('span',selected?.title||'','variant-option__swatch-value');
      legend.append(selectedName);
      group.append(legend);
      variants.forEach(v=>{
        const label=el('label',null,'variant-option__button-label variant-option__button-label--has-swatch tc-ex-color-choice');
        const input=el('input');
        input.type='radio';input.name='tc-ex-variant';input.value=String(v.id);
        input.checked=v.id===selected?.id;
        input.setAttribute('aria-label',v.title+(v.available?'':' - '+c.unavailable));
        if(!v.available){
          label.classList.add('tc-ex-color-unavailable');
          input.setAttribute('aria-disabled','true');
          input.dataset.optionAvailable='false';
        }
        // Same SVG geometry used by the product page's strikethrough-variant.
        // Keep one gentle diagonal inside the coloured circle, never a full cross.
        let strike=null;
        if(!v.available){
          const ns='http://www.w3.org/2000/svg';
          strike=document.createElementNS(ns,'svg');
          strike.setAttribute('viewBox','0 0 100 46');
          strike.setAttribute('preserveAspectRatio','xMidYMid slice');
          strike.classList.add('variant-option__strikethrough');
          strike.setAttribute('aria-hidden','true');
          for(let i=0;i<2;i++){
            const line=document.createElementNS(ns,'line');
            for(const [key,value] of [['x1','100'],['y1','0'],['x2','0'],['y2','46'],['vector-effect','non-scaling-stroke']])line.setAttribute(key,value);
            strike.append(line);
          }
        }
        const dot=el('span',null,'tc-smart-swatch');
        dot.setAttribute('aria-hidden','true');
        dot.style.setProperty('--tc-smart-swatch-background',tcQuickColorFallback(v.title));
        label.title=v.title+(v.available?'':' - '+c.unavailable);
        input.addEventListener('change',()=>{selected=v;update();});
        label.append(input,dot);if(strike)label.append(strike);group.append(label);
        choices.push({input,dot,label,name:v.title});
      });
      picker.append(group);
      info.append(picker);
    }
    const availability=el('p',null,'tc-ex-availability');
    const link=el('a',c.details,'button tc-ex-primary');
    info.append(availability,link);
    const showPhotos=items=>{
      const images=items.length?items:[{src:selected?.featured_image?.src||p.featured_image,alt:p.title}];
      const show=index=>{
        const item=images[index];
        if(!item)return;
        const rendered=image(item.src,item.alt||p.title);
        if(rendered.getAttribute('src')){mainImage.src=rendered.src;mainImage.alt=rendered.alt;}
        for(const [i,btn] of [...thumbs.children].entries())btn.setAttribute('aria-pressed',String(index===i));
      };
      thumbs.replaceChildren();
      if(images.length>1){
        images.forEach((item,i)=>{
          const button=el('button',null,'tc-ex-thumbnail');
          button.type='button';button.setAttribute('aria-label','View image '+(i+1)+' of '+images.length);
          button.setAttribute('aria-pressed',String(i===0));
          button.append(image(item.src,item.alt||p.title));
          button.addEventListener('click',()=>show(i));
          thumbs.append(button);
        });
      }
      show(0);
    };
    const update=()=>{
      const v=selected;
      choices.forEach(({input})=>{input.checked=String(v?.id)===input.value;});
      if(selectedName)selectedName.textContent=v?.title||'';
      price.textContent=money(v?.price??p.price);
      availability.textContent=v?.available?'':c.unavailable;
      link.href=root+'products/'+p.handle+(v?'?variant='+v.id:'');
      showPhotos([{src:v?.featured_image?.src||p.featured_image,alt:p.title}]);
      if(!v)return;
      const requested=++imageRevision;
      tcQuickPage(h,v).then(page=>{
        if(token!==revision||requested!==imageRevision)return;
        for(const choice of choices){
          const input=[...page.querySelectorAll('variant-picker input[data-option-name]')].find(node=>node.value.trim().toLowerCase()===choice.name.trim().toLowerCase());
          const sample=input?.closest('label')?.querySelector('.tc-smart-swatch');
          const sharedColor=sample?.style.getPropertyValue('--tc-smart-swatch-background').trim();
          if(sharedColor)choice.dot.style.setProperty('--tc-smart-swatch-background',sharedColor);
          // Adopt the product page's actual unavailable indicator whenever present.
          const nativeStrike=input?.closest('label')?.querySelector('svg.variant-option__strikethrough');
          if(nativeStrike && choice.label.classList.contains('tc-ex-color-unavailable')){
            const current=choice.label.querySelector('svg.variant-option__strikethrough');
            if(current)current.replaceWith(nativeStrike.cloneNode(true));
          }
        }
        showPhotos(tcQuickPhotos(page,v.title));
      }).catch(()=>{/* Retain selected variant image and fallback colour if the product page cannot load. */});
    };
    body.append(layout);
    status.textContent='';
    update();
  }catch{
    if(token===revision){status.textContent=c.error;const a=el('a',c.details);a.href=root+'products/'+h;body.append(a);}
  }
};
function fallback(trigger,url){open(c.share,'share',trigger);const input=el('input');input.type='text';input.value=url.href;input.readOnly=true;input.setAttribute('aria-label',c.copy);const b=el('button',c.copy);b.type='button';b.addEventListener('click',async()=>{try{await navigator.clipboard.writeText(url.href);status.textContent=c.copied;}catch{input.focus();input.select();}});const wa=el('a','WhatsApp');wa.href='https://wa.me/?text='+encodeURIComponent(url.href);wa.target='_blank';wa.rel='noopener';body.append(input,b,wa);}
document.addEventListener('click',async e=>{const b=e.target.closest('[data-tc-save],[data-tc-quick],[data-tc-wishlist],[data-tc-share]');if(!b)return;e.preventDefault();e.stopImmediatePropagation();if(b.hasAttribute('data-tc-save')){const h=b.dataset.tcSave;if(!valid(h))return;saved=saved.includes(h)?saved.filter(v=>v!==h):[...saved,h].slice(-50);write('trekcamp-wishlist',saved);sync();live.textContent=saved.includes(h)?c.saved:c.remove;if(d.open&&mode==='wishlist')wishlist(opener);}else if(b.hasAttribute('data-tc-wishlist')){const drawer=b.closest('header-drawer');if(drawer?.isOpen)drawer.close();wishlist(b);}else if(b.hasAttribute('data-tc-quick'))quick(b.dataset.tcQuick,b);else{const url=new URL(b.dataset.url,location.origin),v=new URL(location.href).searchParams.get('variant');url.search='';url.hash='';if(v)url.searchParams.set('variant',v);if(navigator.share){try{await navigator.share({title:b.dataset.title,url:url.href});}catch(err){if(err.name!=='AbortError')fallback(b,url);}}else fallback(b,url);}},true);
const current=JSON.parse(document.getElementById('tc-ex-current')?.textContent||'null');
const previous=recent.filter(h=>h!==current).slice(0,12);
if(valid(current)){recent=[current,...recent.filter(h=>h!==current)].slice(0,12);write('trekcamp-recent',recent);}
const region=document.querySelector('.tc-ex-recent');

const recentCard=async h=>{
  const response=await fetch(root+'products/'+h+'?section_id=trekcamp-recent-card');
  if(!response.ok){
    const error=new Error('Recently viewed product could not be loaded');
    error.permanentlyUnavailable=response.status===404||response.status===410;
    throw error;
  }
  const html=await response.text();
  const doc=new DOMParser().parseFromString(html,'text/html');
  const productCard=doc.querySelector('product-card');
  if(!productCard||!productCard.querySelector('.card-gallery img')){
    throw Error('Recently viewed product card is missing its image or markup');
  }
  productCard.classList.add('tc-recent-product-card');
  return document.importNode(productCard,true);
};

if(region&&previous.length){
  const grid=region.querySelector('[data-tc-recent]');
  const renderRecent=async()=>{
    if(!grid||region.dataset.tcRecentLoaded==='true')return;
    region.dataset.tcRecentLoaded='true';
    const cards=[],missing=[];
    // Fill up to four cards, including when an older product was deleted.
    for(let offset=0;offset<previous.length&&cards.length<4;offset+=4){
      const handles=previous.slice(offset,offset+4);
      const results=await Promise.allSettled(handles.map(recentCard));
      results.forEach((result,i)=>{
        if(result.status==='fulfilled'&&cards.length<4){
          cards.push(result.value);
        }else if(result.status==='rejected'&&result.reason?.permanentlyUnavailable){
          missing.push(handles[i]);
        }
      });
    }
    if(missing.length){
      recent=recent.filter(h=>!missing.includes(h));
      write('trekcamp-recent',recent);
    }
    // Remove any reserved placeholders if all previously viewed items are gone.
    if(!cards.length){
      grid.replaceChildren();
      region.hidden=true;
      region.removeAttribute('aria-busy');
      delete region.dataset.tcRecentReserved;
      return;
    }
    grid.replaceChildren(...cards);
    region.removeAttribute('aria-busy');
    delete region.dataset.tcRecentReserved;
    sync();
    region.hidden=false;
  };
  // Observe the reserved recent section itself, or the footer as a fallback.
  const footer=region.dataset.tcRecentReserved==='true'?region:(document.querySelector('footer')||region.previousElementSibling);
  if('IntersectionObserver' in window&&footer){
    const observer=new IntersectionObserver(entries=>{
      if(!entries.some(entry=>entry.isIntersecting))return;
      observer.disconnect();
      void renderRecent();
    },{rootMargin:'400px 0px'});
    observer.observe(footer);
  }else{
    void renderRecent();
  }
}

let pending=false;new MutationObserver(()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;sync();});}).observe(document.getElementById('MainContent'),{childList:true,subtree:true});window.addEventListener('storage',e=>{if(e.key==='trekcamp-wishlist'){saved=read('trekcamp-wishlist');sync();if(d.open&&mode==='wishlist')wishlist(opener);}});sync();
})();

